var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDialog)?_c('confirm-dialog',{staticClass:"border",attrs:{"title":_vm.title,"message":_vm.message,"confirmMsg":_vm.confirmMsg,"showDialog":_vm.showDialog,"noIcons":"","showTextIcon":""},on:{"cancel":_vm.hide,"confirm":_vm.handleConfirm}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }